// The getTenants filter column for the team soft-delete flag (backed by the
// tenant.api.go filter registry). Filter { column: IS_DELETED_COLUMN, eq: "0" }
// scopes a query to active teams.
export const IS_DELETED_COLUMN = "IsDeleted"
